export default __webpack_public_path__ + "static/media/dass.a5cc7194.png";